export default "__VITE_ASSET__CHvfYOV0__"